import { Store, useStore } from '@tanstack/react-store';
import React from 'react';
import { useAppConfig } from '../../AppConfig';

type SavedSearchStore = {
    savedSearchId: number | null;
};

const store = new Store<SavedSearchStore>({
    savedSearchId: null,
});

function setSavedSearchId(savedSearchId: number | null = null) {
    store.setState((state) => {
        return {
            ...state,
            savedSearchId,
        };
    });
}

export function useSavedSearchId() {
    const { initialSavedSearchId } = useAppConfig();

    React.useEffect(
        () => setSavedSearchId(initialSavedSearchId),
        [initialSavedSearchId],
    );

    const savedSearchId = useStore(store, (state) => state.savedSearchId);

    return { savedSearchId, setSavedSearchId };
}
